import { render, staticRenderFns } from "./PluginList.vue?vue&type=template&id=588a2569&scoped=true&"
import script from "./PluginList.vue?vue&type=script&lang=js&"
export * from "./PluginList.vue?vue&type=script&lang=js&"
import style0 from "./PluginList.vue?vue&type=style&index=0&id=588a2569&prod&lang=scss&"
import style1 from "./PluginList.vue?vue&type=style&index=1&id=588a2569&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588a2569",
  null
  
)

export default component.exports